export enum PlatformRecommendationMode {
  RECEIVE = 'receive',
  PAUSE = 'pause',
}
